import { asciiTextValidation } from 'framework/form';

export const changeRequestValidation = {
  id: {
    type: 'string',
    required: false,
  },
  alias: {
    type: 'string',
    required: false,
  },
  title: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  status: {
    type: 'string',
    required: false,
  },
  additionalHours: {
    type: 'number',
    required: false,
  },
  additionalBudgetAmount: {
    type: 'number',
    required: false,
  },
  additionalBudgetAmountId: {
    type: 'string',
    required: false,
  },
  additionalFte: {
    type: 'number',
    required: false,
    minValue: -999,
    maxValue: 999,
  },
  receiverFullName: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  receiverEmail: {
    type: 'string',
    required: true,
    email: true,
  },
  receiverTitle: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  newDeliveryDate: {
    type: 'date',
    required: false,
  },
  billingType: {
    type: 'string',
    required: true,
  },
  billingMilestoneId: {
    type: 'string',
    required: false,
  },
  rawContent: {
    type: 'string',
    required: false,
  },
  companyName: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
};

export const changeRequestRejectValidation = {
  reason: { type: 'string', required: true },
};
